const prefix = process.env.NODE_ENV == 'production' ? "//infishwaibao.oss-cn-chengdu.aliyuncs.com/zyyzhenjiu/" : "./";

export default class RuiQi {
    constructor() {
        this.images = [];
        this.moveTime = 0;
    }
    init(container) {
        let n = this.imagesTotal = 26;
        let loadings = [];

        for (let i = 0; i < n; i++) {
            let s = "";
            if (i < 10) s = '0' + i;
            else {
                s = i;
            }
            let url = `医疗废物00${s}.png`;

            loadings.push(this.loadImage(i, prefix + "feiwutong/" + url));
        }

        this.canvas = document.createElement('canvas');
        this.canvas.width = 512;
        this.canvas.height = 512;
        this.ctx = this.canvas.getContext('2d');
        this.canvas.style.width = "100%";
        this.canvas.style.height = '100%';
        this.ctx.fillStyle = "rgba(90, 203, 237, 0)";

        container.appendChild(this.canvas);

        // this.canvas.addEventListener('mousemove', this.onMouseMove.bind(this), false);
        // this.canvas.addEventListener('mouseout', this.onMouseOut.bind(this), false);

        Promise.all(loadings).then(rets => {
            rets.forEach(item => {
                this.images[item.i] = item.img;
            })
            this.imgInit();
        });


    }

    loadImage(i, url) {
        return new Promise((resolve, reject) => {
            let img = new Image();
            img.src = url;
            img.onload = function () {
                resolve({ i, img });
            };
        });
    }
    imgInit() {
        let image = this.images[0];
        this.ctx.clearRect(0, 0, 512, 512);
        this.ctx.fillRect(0, 0, 512, 512);
        this.ctx.drawImage(image, 0, 0);
    }
    onMouseMove() {
        if (!this.openTimmer) {
            this.open()
        }
    }
    open() {
        let index = 0;
        this.openTimmer = setInterval(() => {
            index = index + 1;
            let image = this.images[index - 1];
            if (index >= this.imagesTotal) {
                clearInterval(this.openTimmer);
                this.closeTimmer = null;
                return false;
            }
            this.ctx.clearRect(0, 0, 512, 512);
            this.ctx.fillRect(0, 0, 512, 512);
            this.ctx.drawImage(image, 0, 0);

        }, 10)
    }
    onMouseOut() {
        if (this.openTimmer && !this.closeTimmer) {
            this.close();
        }

    }
    close() {
        let index = this.imagesTotal;
        this.closeTimmer = setInterval(() => {
            let image = this.images[index - 1];
            index = index - 1;
            if (index < 0) {
                clearInterval(this.closeTimmer);
                this.openTimmer = null;
                return false;
            }
            this.ctx.clearRect(0, 0, 512, 512);
            this.ctx.fillRect(0, 0, 512, 512);
            this.ctx.drawImage(image, 0, 0);
        }, 10)
    }


}